<template>
  <v-container grid-list-xs fluid>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-progress-linear
              v-if="loading"
              indeterminate
              height="5"
          />
          <v-flex v-else xs12 sm6 offset-sm3>
              <v-card color="primary">
                <v-list three-line v-for="(item, index) in listaIndicadosRegiao">
                  <v-list-tile
                    :key="item.co_indicado_conselho"
                    avatar
                    ripple
                  >
                    <v-list-tile-avatar
                      tile
                      :size="$vuetify.breakpoint.mdAndDown? 60: 90"
                      max-size="90"
                      class="my-1 mr-3"
                    >
                      <v-img :src="item.foto_rosto" v-if="!loadingFoto" style="z-index: 2;"/>
                      <v-progress-circular v-else-if="loadingFoto" indeterminate style="z-index: 2;" color="primary"/>
                      <v-icon style="z-index: 1; position: absolute;" :size="$vuetify.breakpoint.mdAndDown? 60: 90">account_circle</v-icon>
                    </v-list-tile-avatar>
                
                    <v-list-tile-content>
                      <v-list-tile-title><strong>{{ item.indicado.no_nome_votacao.toUpperCase() }}</strong></v-list-tile-title>
                      <v-list-tile-sub-title><strong>UF: </strong>{{ item.indicado.no_uf_indicado }}</v-list-tile-sub-title>
                      <v-list-tile-sub-title><strong>Região: </strong>{{ item.indicado.no_regiao_indicado }}</v-list-tile-sub-title>
                      <v-list-tile-sub-title><strong>Currículo: </strong> <a :href="item.curriculo_resumido" target="_blank">abrir <v-icon x-small small color="primary">open_in_new</v-icon></a></v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-icon v-if="index < 4" :color="index < 2 ? 'success' : 'warning'" large left :title="index < 2 ? 'Eleito como Titular':'Eleito como Suplente'">star</v-icon>
                      <v-list-tile-title class="text-xs-center"><strong>{{item.totalVotos}} VOTO<span v-if="item.totalVotos > 1 || item.totalVotos == 0">S</span> </strong></v-list-tile-title>
                    </v-list-tile-action>

                  </v-list-tile>
                  <v-divider
                    v-if="index + 1 < listaIndicadosRegiao.length"
                    :key="index"
                    class="mt-2"
                  />
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import codigosPerfil from '../../../conta/utils/codigosPerfil';

export default {
  name: 'VotacaoResultadoComponent',
  components: {
  },
  props: {
    coRegiao: {
      type: Number,
      default: 0,
    },
    nomeRegiao: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    codigosPerfil,
    loading: true,
    loadingFoto: true,
    listaIndicadosRegiao: [],
    indicadoVotado: {},
  }),
  watch: {
    listaIndicadosRegiao(){
      this.listaIndicadosRegiao.forEach(item => {
        if(!item.indicado || !item.indicado.arquivos.length){
          return;
        }
        let tp_arquivo_foto_indicado = item.indicado.arquivos.some(e => e.tp_arquivo === 'foto_indicado_formatada') ? 'foto_indicado_formatada' : 'foto_indicado';
        let tp_arquivo_curriculo_indicado = item.indicado.arquivos.some(e => e.tp_arquivo === 'curriculo_resumido_indicado_formatado')? 'curriculo_resumido_indicado_formatado': 'curriculo_resumido_indicado';

        this.obterBinario(item.indicado.arquivos.find(a => a.tp_arquivo == tp_arquivo_foto_indicado).co_arquivo).then(response => {
          this.loadingFoto = true;
          item.foto_rosto = response;
          this.loadingFoto = false;
        });
        this.obterBinario(item.indicado.arquivos.find(a => a.tp_arquivo == tp_arquivo_curriculo_indicado).co_arquivo).then(response => {
          item.curriculo_resumido = response;
        });
      });
      this.loading = false;
    },
    usuario() {
      this.checkUsuario()
    },
  },
  computed: {
    ...mapGetters({
      usuario: 'conta/usuario',
      perfil: 'conta/perfil',

      fases: 'fase/fases',

      listaFinalRanking: 'votacao/listaFinalRanking',
    }),
  },
  methods: {
    ...mapActions({
      obterUsuarioLogado: 'conta/tratarUsuarioLogado',
      
      obterResultadoVotacaoPorRegiao: 'votacao/obterResultadoVotacaoPorRegiao',
      definirMensagemErro: 'app/setMensagemErro',
      obterBinario: 'shared/obterImagemArquivo'
    }),

    checkUsuario() {
      if (this.perfil.co_perfil != codigosPerfil.CODIGO_ADMINISTRADOR) {
        this.definirMensagemErro('Usuário não permitido!');
        this.$router.push('/');
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.loading = true;

    this.obterUsuarioLogado();

    this.usuarioLogado = this.usuario;

    if(this.listaIndicadosRegiao.length == 0){
     this.obterResultadoVotacaoPorRegiao(this.coRegiao).then( response => this.listaIndicadosRegiao = response.data);
    }
  },
};
</script>
